/**
 * Segmented OTP input for the MFA code entry form.
 *
 * Provides:
 * - Auto-advance to the next digit box on input
 * - Backspace navigates to the previous box when current is empty
 * - Paste distributes digits across all boxes
 * - Combines digit values into a hidden field for form submission
 * - Only numeric input is accepted
 */
(function () {
    'use strict';

    function initMfaOtp() {
        const container = document.querySelector('.mfa_otpContainer');

        if (!container) {
            return;
        }

        const digits = Array.from(container.querySelectorAll('.mfa_otpDigit'));
        const hiddenInput = container.querySelector('input[type="hidden"]');
        const form = container.closest('form');

        if (!hiddenInput || digits.length === 0) {
            return;
        }

        function combineDigits() {
            hiddenInput.value = digits.map(function (input) {
                return input.value;
            }).join('');

            // Toggle filled class for styling
            digits.forEach(function (input) {
                input.classList.toggle('filled', input.value !== '');
            });
        }

        function focusDigit(index) {
            if (index >= 0 && index < digits.length) {
                digits[index].focus();
                digits[index].select();
            }
        }

        digits.forEach(function (input, index) {
            // Input: accept only digits, auto-advance
            input.addEventListener('input', function (event) {
                // Strip non-numeric characters
                const value = event.target.value.replace(/[^0-9]/g, '');

                if (value.length > 1) {
                    // Multiple characters (e.g. from paste without paste event)
                    distributeValue(value);
                    return;
                }

                event.target.value = value;
                combineDigits();

                if (value && index < digits.length - 1) {
                    focusDigit(index + 1);
                }
            });

            // Keydown: handle backspace navigation
            input.addEventListener('keydown', function (event) {
                if (event.key === 'Backspace' && !input.value && index > 0) {
                    event.preventDefault();
                    digits[index - 1].value = '';
                    combineDigits();
                    focusDigit(index - 1);
                }

                if (event.key === 'ArrowLeft' && index > 0) {
                    event.preventDefault();
                    focusDigit(index - 1);
                }

                if (event.key === 'ArrowRight' && index < digits.length - 1) {
                    event.preventDefault();
                    focusDigit(index + 1);
                }
            });

            // Paste: distribute digits across boxes
            input.addEventListener('paste', function (event) {
                event.preventDefault();
                const pastedText = (event.clipboardData || window.clipboardData).getData('text');
                distributeValue(pastedText);
            });

            // Focus: select existing value for easy replacement
            input.addEventListener('focus', function () {
                input.select();
            });
        });

        function distributeValue(value) {
            const numericValue = value.replace(/[^0-9]/g, '').slice(0, digits.length);

            for (let i = 0; i < digits.length; i++) {
                digits[i].value = numericValue[i] || '';
            }

            combineDigits();

            // Focus the next empty box, or the last box
            const nextEmpty = digits.findIndex(function (input) {
                return !input.value;
            });
            focusDigit(nextEmpty === -1 ? digits.length - 1 : nextEmpty);
        }

        // Combine on form submit as a safety net
        if (form) {
            form.addEventListener('submit', combineDigits);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initMfaOtp);
    } else {
        initMfaOtp();
    }
})();
